import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const BoxOne = () => {
    return (
        <div className="App">
            <div className="App-body">
                <h1>Box One - Location: Nina's Cubicle</h1>
                <p>
                Determined to find out what happened, you make your way to Nina’s cubicle. The sight that greets you is 
                unsettling—her usually tidy workspace is now a chaotic mess. Papers are strewn everywhere, personal belongings 
                are scattered about, but her laptop remains untouched.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='ContextOne'>Continue</Button>
            </div>
        </div>
    );
  };
  
export default BoxOne;
  